import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Ciudad } from "@/shared/types/ciudad";

export async function checkCiudad(codigo: string): Promise<Ciudad | null> {
    await sleep(1000);
    const { data } = await api.get("ciudades/check/" + codigo);
    return data ? data : null;
}

export function useCheckCiudadQuery(codigo: string, queryConfig: QueryConfig<Ciudad | null> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await checkCiudad(codigo),
        queryKey: ["ciudades", "check", codigo],
    });
}

export interface CheckCiudadQueryProps {
    codigo: string;
    queryConfig?: QueryConfig<Ciudad | null>;
    children?: (queryResult: QueryResult<Ciudad | null>) => ReactNode;
}

export function CheckCiudadQuery({
    codigo,
    queryConfig,
    children,
}: CheckCiudadQueryProps) {
    const queryResult = useCheckCiudadQuery(codigo, queryConfig);
    return children && children(queryResult);
}
